module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDE0IDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuNCIgZD0iTTEyLjYwMDEgMC42MDAwMDZMNi45NTM2NSA2LjI0NjQ1QzYuNzU4MzkgNi40NDE3MSA2LjQ0MTgxIDYuNDQxNzEgNi4yNDY1NCA2LjI0NjQ1TDAuNjAwMDk4IDAuNjAwMDA2IiBzdHJva2U9IiMwMDIzMkEiIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico-svg/Flecha selector.svg
// module id = eRz3
// module chunks = 62